import LocationPageTemplate from '../LocationPageTemplate';
import { locationFaqs } from '../../../mocks/faqs';

export default function StPetersburgPage() {
  return (
    <LocationPageTemplate
      city="St. Petersburg"
      heroImage="https://www.parksidepavers.com/files/projects/16/images/thumb/thumb_large_IMG%5F2840%2Ejpg"
      description="Premium paver installation services in St. Petersburg, FL — custom patios, driveways, pool decks, and outdoor living spaces for St. Pete homeowners."
      geoDescription="Parkside Pavers serves St. Petersburg with expert hardscape installation. Paver installation in St. Petersburg, patio design near St. Pete, and driveway pavers throughout Pinellas County — delivered with ICPI-certified craftsmanship."
      mapEmbedSrc="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d112877.54321234567!2d-82.7400!3d27.7731!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2e67f99999999%3A0x0!2sSt.%20Petersburg%2C%20FL!5e0!3m2!1sen!2sus!4v1699000000000!5m2!1sen!2sus"
      faqs={locationFaqs['st-petersburg']}
    />
  );
}
